import { TabGroup, Typography } from 'procyon-ui'
import React from 'react'
import { ApplicationsList } from './components/Tabs/ApplicationsList'
import { AvailableApps } from './components/Tabs/AvailableApps'
import useAppView from 'Core/Hooks/useAppView'
import { createRsrcKey, useResourceDetails } from 'features/resources'

const Applications = () => {
  const { rsrc } = useResourceDetails()
  const { viewMode } = useAppView()

  const tabs = [
    {
      label: 'Active Applications',
      tabContent: <ApplicationsList />
    }
  ]

  if (viewMode == 'admin') {
    tabs.push({
      label: 'Add Application',
      tabContent: <AvailableApps />
    })
  }

  return (
    <>
      <div className='flex justify-between'>
        <Typography variant='h3'>Applications</Typography>
      </div>
      <div className='mt-8'>
        <TabGroup
          activeIndex={0}
          key={createRsrcKey(rsrc)}
          onChangeTab={function noRefCheck() {}}
          tabs={tabs}
        />
      </div>
    </>
  )
}

export { Applications }
